module.exports = __webpack_public_path__ + "static/media/search.f351a59a.svg";